<template>
  <loading-icon class="c-card c-card--claims-list" v-if="!loaded"></loading-icon>
  <section class="c-card c-card--claims-list" v-else>



    <div class="c-card__header">
      <h2 class="c-card__header__title t-headline">{{ card.title }}</h2>
      <i class="c-card__header__icon fa fa-inbox t-headline"></i>
    </div>



    <template v-if="approverClaims.length == 0">
      <div class="c-card__body t-text-color">
        <div class="c-card--claims-list__empty">
          <i class="c-card--claims-list__empty__icon fa fa-thumbs-up"></i>
          <p class="c-card--claims-list__empty__text">
            {{ $t('web.card_claims_approver.no_claims_to_approve') }}
          </p>
        </div>
      </div>
    </template>



    <template v-if="approverClaims.length > 0">
      <div class="c-card__body c-card--claims-list__body">


        <transition name="fade-and-slide">
          <div ref="claimToast"
            v-if="claimModalMessage !== null && claimModalType == 'approver'"
            class="c-toast t-toast-success">
            <p class="c-toast__text">{{ claimModalMessage }}</p>
          </div>
        </transition>


        <section>
          <h2
            v-if="pendingForThisPage.length > 0"
            class="c-card__subtitle-h2 c-card--claims-list__subtitle-h2"
          >
            {{ $t('web.card_claims_approver.pending_claims') }}
          </h2>

          <div
            class  = "c-card--claims-list__claim"
            v-for  = "claim in pendingForThisPage"
            @click = "showClaim(claim.id)"
            :key   = "claim.id"
          >

            <div class="c-card--claims-list__claim__info">

              <h3 class="c-card--claims-list__claim__info__pax">{{ claim.participant_name }}</h3>

              <div class="c-card--claims-list__claim__info__details">
                <span class="c-card--claims-list__claim__info__details__date">{{ claim.created_at }}</span>
                <span class="c-card--claims-list__claim__info__details__form">{{ claim.form_name }}</span>
              </div>

            </div>

            <div class="c-approvals__claim__status">
              <button class="c-status" v-bind:class="claimStatusClass(claim)">
                {{ $t(CLAIM_STATUS_TRANSLATION[claim.status]) }}
              </button>
            </div>

          </div>

        </section>


        <section>
          <h2
            v-if  = "(notPendingForThisPage.length > 0) && (pendingForThisPage.length > 0)"
            class = "c-card__subtitle-h2 c-card--claims-list__subtitle-h2"
          >
            {{ $t('web.card_claims_approver.other_claims') }}
          </h2>
          <div v-else class="u-margin-top-15"></div>

          <div
            class  = "c-card--claims-list__claim"
            v-for  = "claim in notPendingForThisPage"
            @click = "showClaim(claim.id)"
            :key   = "claim.id"
          >

            <div class="c-card--claims-list__claim__info">

              <h3 class="c-card--claims-list__claim__info__pax">{{ claim.participant_name }}</h3>

              <div class="c-card--claims-list__claim__info__details">
                <span class="c-card--claims-list__claim__info__details__date">{{ claim.created_at }}</span>
                <span class="c-card--claims-list__claim__info__details__form">{{ claim.form_name }}</span>
              </div>

            </div>

            <div class="c-approvals__claim__status">
              <button class="c-status" v-bind:class="claimStatusClass(claim)">
                {{ $t(CLAIM_STATUS_TRANSLATION[claim.status]) }}
              </button>
            </div>

          </div>
        </section>


      </div>
    </template>

     <paginate
        :pagination="pagination"
        :pagingCallback="setPage">
      </paginate>

  </section>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import $ from 'jquery'
import util from '@/functions'
import Paginate from '../shared/Paginate'
import { CLAIM_STATUS, CLAIM_STATUS_TRANSLATION } from '@/enums'

export default {
  props: ['card', 'loaded'],
  components: {
    paginate: Paginate
  },
  data () {
    return {
      pageNumber: 1,
      CLAIM_STATUS,
      CLAIM_STATUS_TRANSLATION
    }
  },
  methods: {
    ...mapActions([
      'LOAD_APPROVER_CLAIM'
    ]),
    ...mapMutations([
      'UPDATE_CLAIM_MODAL_DATA',
      'UPDATE_CLAIM_MODAL_SHOW',
      'UPDATE_CLAIM_MODAL_TYPE'
    ]),
    showClaim (id) {
      $('body').addClass('has-modal')
      this.UPDATE_CLAIM_MODAL_DATA(_.find(this.approverClaims, {'id': id}))
      this.UPDATE_CLAIM_MODAL_SHOW(true)
      this.UPDATE_CLAIM_MODAL_TYPE('approver')
      this.LOAD_APPROVER_CLAIM(id).then(() => {
        this.UPDATE_CLAIM_MODAL_DATA(_.find(this.approverClaims, {'id': id}))
      })
    },
    claimStatusClass (claim) {
      console.log(claim.status)
      return {
        't-alert-success': claim.status === CLAIM_STATUS.APPROVED,
        't-alert-danger': claim.status === CLAIM_STATUS.UPDATE_NEEDED,
        't-alert-warning': claim.status === CLAIM_STATUS.PENDING,
        't-alert-info': claim.status === CLAIM_STATUS.DECLINED
      }
    },
    setPage (pageNumber) {
      this.pageNumber = pageNumber
    }
  },
  computed: {
    ...mapGetters([
      'approverClaims',
      'claimModalMessage',
      'claimModalType'
    ]),
    pageMap   () {
      return util.getPageMap(
        this.pagination.per_page_count,
        this.pagination.pages,
        this.totalPending,
        this.totalNotPending
      )
    },
    pagination () {
      let pagination = {
        current: this.pageNumber,
        per_page_count: 10,
        count: this.totalPending + this.totalNotPending
      }
      pagination.pages = util.getPagination(this.pageNumber, Math.ceil(pagination.count / pagination.per_page_count))
      pagination.previous = (this.pageNumber === 1) ? null : this.pageNumber - 1
      pagination.next = (this.pageNumber === _.last(pagination.pages)) ? null : this.pageNumber + 1
      return pagination
    },
    pending () {
      return _.pickBy(this.approverClaims, function (claim) {
        return claim.status === CLAIM_STATUS.PENDING
      })
    },
    pendingForThisPage () {
      let page = this.pageMap[this.pageNumber]
      let slice = _.slice(_.values(this.pending), page.topGroupStart, page.topGroupCount + page.topGroupStart)
      return slice
    },
    totalPending () {
      return Object.keys(this.pending).length
    },
    notPending () {
      return _.pickBy(this.approverClaims, function (claim) {
        return claim.status !== CLAIM_STATUS.PENDING
      })
    },
    notPendingForThisPage () {
      let page = this.pageMap[this.pageNumber]
      let slice = _.slice(_.values(this.notPending), page.bottomGroupStart, page.bottomGroupCount + page.bottomGroupStart)
      return slice
    },
    totalNotPending () {
      return Object.keys(this.notPending).length
    }
  }
}
</script>

<style lang="sass" scoped>

.fade-and-slide-leave-active
  max-height: 80px
  transition: opacity 1s, max-height 1s

.fade-and-slide-leave-to
  max-height: 0
  opacity: 0

</style>



// WEBPACK FOOTER //
// ClaimsApprover.vue?2a9d44b3